// extracted by mini-css-extract-plugin
export default {"mainText":"UserModal_mainText__uqQCM","btnCustom":"UserModal_btnCustom__8ok8M","page":"UserModal_page__Cutzg","inp":"UserModal_inp__e69Ka"};